<div class="externe-daten">
  @if (gebaeude) {
    <cap-content-header>
      <cap-title>
        {{ "GWRGebaeude" | translate }}
        : {{ gebaeude.gebaeudeBezeichnung ? " " + gebaeude.gebaeudeBezeichnung + ", " : "" }} EGID: {{ gebaeude.egid.value }}
      </cap-title>
    </cap-content-header>
  }

  @if (gebaeude) {
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement [value]="gebaeude.gebaeudeBezeichnung" label="Bezeichnung"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.gemeinde.name" label="Gemeinde"></cap-kopfdatenelement>
        <cap-kopfdatenelement label="Gebaeudeflaeche">
          {{ gebaeude.flaeche ? (gebaeude.flaeche | decimalHochkomma) + "&nbsp;m²" : "" }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.versicherungsNummer" label="Versicherungsnummer"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.gebaeudeStatus | translate" label="GEBAEUDESTATUS"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.gebaeudeKategorie | translate" label="GEBAEUDEKATEGORIE"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.gebaeudeKlasse | translate" label="GEBAEUDEKLASSE"></cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        @if (hasExternalGWR()) {
          <cap-kopfdatenelement label="EGID">
            <a
              (click)="openExternalGWRLink(gebaeude.egid?.value)"
              [ngbTooltip]="'DetailsZuGebaeudeWohnungsregister' | translate"
              container="body"
              style="cursor: pointer">
              {{ gebaeude.egid?.value }}
            </a>
          </cap-kopfdatenelement>
        }
        @if (!hasExternalGWR()) {
          <cap-kopfdatenelement label="EGID">{{ gebaeude.egid?.value }}</cap-kopfdatenelement>
        }
        <cap-kopfdatenelement [value]="gebaeude.anzahlWohnungen" label="AnzahlWohnungen"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.anzahlGeschosse" label="AnzahlGeschosse"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.anzahlWohnraeume" label="AnzahlWohnraeume"></cap-kopfdatenelement>
        <cap-kopfdatenelement
          [value]="gebaeude.baujahr | gwrBaujahrPeriodePipe: gebaeude.bauperiode"
          label="Baujahr"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.renovationsjahr" label="Renovationsjahr"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="gebaeude.abbruchjahr" label="Abbruchjahr"></cap-kopfdatenelement>
      </div>
      <div class="col-md-12 col-sm-12">
        <cap-kopfdatenelement label="Adressen" labelClass="col-md-2">
          @for (adresse of gebaeude.eingangAdressen; track adresse) {
            <div>
              {{ adresse | kompaktGwrGebaeudeeingangsadresse }}
            </div>
          }
        </cap-kopfdatenelement>
      </div>
    </div>
    <cap-gwr-wohnung-table [listLoader]="wohnungListLoader">
      <div class="title-divider" name="title">
        <h2>{{ "Wohnungen" | translate }}</h2>
      </div>
    </cap-gwr-wohnung-table>
    <cap-gwr-grundstueck-table [listLoader]="grundstueckListLoader">
      <div class="title-divider" name="title">
        <h2>{{ "BetroffeneGrundstücke" | translate }}</h2>
      </div>
    </cap-gwr-grundstueck-table>
  } @else {
    <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
  }
</div>
